export default __webpack_public_path__ + "static/media/instagram.ae3e882f.svg";